var axios = require('axios');
function ajaxCalls() {
    return {
        'getExams': function(userId,apiUrl,callback) {
            axios({
                method:'get',
                url : apiUrl + 'practiceExam/' + userId+'/getExams',
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        'resetExam':function(userId,examId,apiUrl,callback) {
            axios({
                method:'post',
                url : apiUrl + 'practiceExam/' + userId+'/resetExam/' + examId,
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        'deleteExam':function(userId,examId,apiUrl,callback) {
            axios({
                method:'get',
                url : apiUrl + 'practiceExam/' + userId+'/deleteExam/' + examId,
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        // JayG Jun 29, 2023 #26230828 Add parameter for randomize
        'getExam':function(userId,examId,apiUrl,callback,randomize) {
            randomize = typeof randomize == "undefined" ? true : randomize;
            axios({
                method:'get',
                // JayG Jun 29, 2023 #26230828 Add parameter for randomize
                url: apiUrl + 'practiceExam/' + examId + '/get?randomize=' + (randomize ? '1' : '0'),
            }).then(function(response) {
                callback(response.data);
            })
        },
        'ping':function(userId,examId,elapsedTime,questionIndex,apiUrl) {
            axios({
                method:'get',
                params: {
                    userId: userId,
                    questionIndex:questionIndex,
                    elapsed_time: elapsedTime,
                },
                url: apiUrl + 'practiceExam/' + examId + '/ping/',
            });
        },
        'updateAnswer':function(userId,examId,answer) {

            var answerObj = {
                userId: userId,
                examId:examId,
                answer: answer.answer,
                status: answer.status,
                guessed: answer.guessed,
            };
            if (answer.rating !== 'null') {
                answerObj.rating = answer.rating;
            }
            axios({
                method:'get',
                params: answerObj,
                url: apiUrl + 'practiceExam/' + answer.id + '/updateAnswer/',
            });
        },
        'scoreExam':function(userId,examId,answer) {

            var answerObj = {
                userId: userId,
                examId:examId,
                answer: answer.answer,
                answerId: answer.id,
                status: answer.status,
                guessed: answer.guessed,
            };
            if (answer.rating !== 'null') {
                answerObj.rating = answer.rating;
            }
            axios({
                method:'get',
                params: answerObj,
                url: apiUrl + 'practiceExam/' + examId + '/scoreExam/',
            });
        },
        'report':function(question_id,user_id,message,callback) {
            axios({
                method:'get',
                url: apiUrl+'practiceExam/' + question_id + '/feedback',
                params: {
                    user_id : user_id,
                    message : message
                }
            }).then(function(response) {
                callback(response.data);
            })
        },
        'getQuizzes': function(userId,apiUrl,callback) {
            axios({
                method:'get',
                url : apiUrl + 'quiz/' + userId+'/getQuizzes',
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        'resetQuiz':function(userId,quizId,apiUrl,callback) {
            axios({
                method:'post',
                url : apiUrl + 'quiz/' + userId+'/reset/' + quizId,
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        'deleteQuiz':function(userId,quizId,apiUrl,callback) {
            axios({
                method:'get',
                url : apiUrl + 'quiz/' + userId+'/delete/' + quizId,
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        'deleteAllQuiz':function(userId,quizId,apiUrl,callback) {
            axios({
                method:'delete',
                url : apiUrl + 'quiz/' + userId,
            })
                .then(function(response){
                    callback(response.data);
                })
        },
        // JayG Jun 29, 2023 #26230828 Add parameter for randomize
        'getQuiz':function(userId,quizId,apiUrl,callback,randomize) {
            randomize = typeof randomize == "undefined" ? true : randomize;
            axios({
                method:'get',
                // JayG Jun 29, 2023 #26230828 Add parameter for randomize
                url: apiUrl + 'quiz/' + quizId + '/get?randomize=' + (randomize ? '1' : '0'),
            }).then(function(response) {
                callback(response.data);
            })
        },
        'quizPing':function(userId,quizId,questionIndex,apiUrl) {
            axios({
                method:'get',
                params: {
                    userId: userId,
                    questionIndex:questionIndex,
                },
                url: apiUrl + 'quiz/' + quizId + '/ping/',
            });
        },
        'quizUpdateAnswer':function(userId,quizId,answer) {

            var answerObj = {
                userId: userId,
                quizId:quizId,
                answer: answer.answer,
                status: answer.status,
                guessed: answer.guessed,
            };
            if (answer.rating !== 'null') {
                answerObj.rating = answer.rating;
            }
            axios({
                method:'get',
                params: answerObj,
                url: apiUrl + 'quiz/' + answer.id + '/updateAnswer/',
            });
        },
        'scoreQuiz':function(userId,quizId,answer) {

            var answerObj = {
                userId: userId,
                examId:quizId,
                answer: answer.answer,
                answerId: answer.id,
                status: answer.status,
                guessed: answer.guessed,
            };
            if (answer.rating !== 'null') {
                answerObj.rating = answer.rating;
            }
            axios({
                method:'get',
                params: answerObj,
                url: apiUrl + 'quiz/' + quizId + '/scoreQuiz/',
            });
        },
    }
}

module.exports = new ajaxCalls;


//////////////////
// WEBPACK FOOTER
// ./src/ajaxCalls.js
// module id = 5
// module chunks = 0